import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    usersData: [],
    rolesList: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getAllUsers = createAsyncThunk(
    "usermanagement/users",
    async ({ user, pagination, orderBy, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            const { sortColumn, isAsce } = orderBy;

            const base = url?.backoffice;
            const endpointpath = endpoint?.backoffice?.getusers;
            const institution = user?.institution?.value

            const apiURL = base + endpointpath + institution + `/${pageSize}/${currentPage}/${sortColumn}/${isAsce}`;

            const response = await axiosInstance.post(apiURL, search);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const getRolesListByInstitution = createAsyncThunk(
    "usermanagement/rolesListByInstitution",
    async ({ user, institution }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.backoffice;
            const endpointpath = endpoint?.backoffice?.role;
            const list = endpoint?.backoffice?.list;
            const isSuperAdmin = false;

            const apiURL = base + endpointpath + list + institution + '/' + isSuperAdmin;

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            throw error.response;
        }
    }
);

export const postAddUpdateUser = createAsyncThunk(
    "user-management/add-update-user",
    async ({ user, body, update }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.backoffice;
            const endpointpath = update ? endpoint?.backoffice?.updateuser : endpoint?.backoffice?.adduser;

            const apiURL = base + endpointpath;

            const method = update ? 'put' : 'post';
            const response = await axiosInstance[method](apiURL, body);

            toast.success('Request has been initiated and sent to checker');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const usersSlice = createSlice({
    name: "users",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET ALL USERS
            .addCase(getAllUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllUsers.fulfilled, (state, action) => {
                const { resp, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.usersData = resp || [];
                state.pagination = { currentPage, pageSize, totalItem, totalPages };
            })
            .addCase(getAllUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.usersData = [];
                state.pagination = null;
            })

            // GET ROLES LIST BY INSTITUTION
            .addCase(getRolesListByInstitution.fulfilled, (state, action) => {
                state.rolesList = action?.payload || [];
            })
            .addCase(getRolesListByInstitution.rejected, (state, action) => {
                state.rolesList = [];
            })

            // ADD USER
            .addCase(postAddUpdateUser.pending, (state) => {
                state.error = null;
            })
            .addCase(postAddUpdateUser.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddUpdateUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default usersSlice.reducer;